import { Phone, MessageCircle } from 'lucide-react';

export const FloatingButtons = () => {
  const phoneNumber = "+4916092653278";
  const whatsappMessage = encodeURIComponent("Hallo, ich interessiere mich für Ihre Reinigungsleistungen.");

  return (
    <div className="floating-buttons" data-testid="floating-buttons">
      {/* Phone Button */}
      <a
        href={`tel:${phoneNumber}`}
        className="flex items-center justify-center w-14 h-14 bg-[#003366] hover:bg-[#002244] text-white rounded-full shadow-lg transition-all duration-300 hover:-translate-y-1"
        aria-label="Anrufen"
        data-testid="floating-phone-btn"
      >
        <Phone className="w-6 h-6" />
      </a>

      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber.replace('+', '')}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-lg transition-all duration-300 hover:-translate-y-1"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingButtons;
